import { useState } from 'react'
import { API } from '../lib/api'
import Logo from './Logo'

const TYPES = ['Vidéo corporative ou industrielle', 'Vidéo de recrutement', 'Reels et contenu pour les réseaux sociaux', 'Prises de vue par drone', 'Autre projet']
const input = 'w-full bg-black/40 border border-white/10 rounded px-4 py-3 text-sm focus:border-orange outline-none placeholder:text-acier/60'
const label = 'block text-[11px] uppercase tracking-widest text-acier mb-1'

/** Formulaire de contact public : envoie la demande à info@pivot-media.ca et l'enregistre pour l'admin. */
export function ContactSection({ title = 'Parlons de votre projet', page = '' }: { title?: string; page?: string }) {
  const [f, setF] = useState({ name: '', email: '', phone: '', company: '', project_type: TYPES[0], message: '', website: '' })
  const [state, setState] = useState<'idle' | 'busy' | 'done' | 'error'>('idle')
  const [err, setErr] = useState('')
  const set = (k: keyof typeof f, v: string) => setF(x => ({ ...x, [k]: v }))

  async function submit(e: React.FormEvent) {
    e.preventDefault(); setState('busy'); setErr('')
    try {
      const r = await fetch(`${API}/contact`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...f, page: page || window.location.pathname, source: 'site web' }) })
      const j = await r.json().catch(() => ({}))
      if (!r.ok) throw new Error(j.error || `Erreur ${r.status}`)
      setState('done')
    } catch (e: any) { setErr(e.message); setState('error') }
  }

  return (
    <section id="contact" className="px-6 md:px-12 py-24 border-t border-white/5">
      <div className="max-w-5xl mx-auto grid lg:grid-cols-5 gap-12 items-start">
        <div className="lg:col-span-2">
          <Logo className="items-start mb-8" />
          <h2 className="font-display text-4xl md:text-5xl tracking-wide leading-none">{title}</h2>
          <p className="text-acier mt-5 leading-relaxed">Décrivez-nous votre entreprise et ce que la vidéo doit accomplir. On vous répond en moins de 24 heures pour planifier une rencontre, puis on vous envoie un devis. Sans engagement.</p>
          <div className="mt-8 space-y-2 text-sm">
            <a href="mailto:info@pivot-media.ca" className="block text-blanc hover:text-orange transition-colors">info@pivot-media.ca</a>
            <p className="text-acier">Partout au Québec</p>
          </div>
        </div>

        <div className="lg:col-span-3 border border-white/10 rounded p-6 md:p-8 bg-white/[0.02]">
          {state === 'done' ? (
            <div className="text-center py-10">
              <div className="text-orange text-5xl mb-4">✓</div>
              <h3 className="font-display text-3xl tracking-wide">Demande envoyée</h3>
              <p className="text-acier mt-3">Merci {f.name.split(' ')[0]}. On vous écrit à {f.email} d'ici 24 heures.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="grid sm:grid-cols-2 gap-4">
              <div><label className={label}>Votre nom *</label><input className={input} value={f.name} onChange={e => set('name', e.target.value)} required autoComplete="name" /></div>
              <div><label className={label}>Entreprise</label><input className={input} value={f.company} onChange={e => set('company', e.target.value)} autoComplete="organization" /></div>
              <div><label className={label}>Courriel *</label><input type="email" className={input} value={f.email} onChange={e => set('email', e.target.value)} required autoComplete="email" /></div>
              <div><label className={label}>Téléphone</label><input type="tel" className={input} value={f.phone} onChange={e => set('phone', e.target.value)} autoComplete="tel" /></div>
              <div className="sm:col-span-2"><label className={label}>Type de projet</label>
                <select className={input} value={f.project_type} onChange={e => set('project_type', e.target.value)}>{TYPES.map(t => <option key={t}>{t}</option>)}</select></div>
              <div className="sm:col-span-2"><label className={label}>Votre demande *</label>
                <textarea className={input + ' min-h-[130px]'} value={f.message} onChange={e => set('message', e.target.value)} required placeholder="Votre entreprise, le but de la vidéo, le public visé, l'échéance souhaitée…" /></div>
              <input type="text" name="website" value={f.website} onChange={e => set('website', e.target.value)} className="hidden" tabIndex={-1} autoComplete="off" aria-hidden="true" />
              {err && <p className="sm:col-span-2 text-red-300 text-sm">{err}</p>}
              <div className="sm:col-span-2 flex flex-wrap items-center gap-4">
                <button disabled={state === 'busy'} className="bg-orange hover:bg-orange-hover transition-colors px-8 py-4 uppercase tracking-widest text-sm font-bold rounded-sm disabled:opacity-50">
                  {state === 'busy' ? 'Envoi…' : 'Envoyer ma demande'}
                </button>
                <span className="text-xs text-acier">Réponse en 24 h, puis rencontre, puis devis.</span>
              </div>
            </form>
          )}
        </div>
      </div>
    </section>
  )
}
